
import store from "@/store";
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { touristApi } from "../../../api/farmerSpace";
import { ImagePreview } from "vant";

import { convertSec2Str } from "@/utils/util";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
interface paramType {
  lat: string;
  lng: string;
  sourceId: any;
}
interface initInfoType {
  img: Array<any>;
  shotImg: Array<any>;
  detailImg: Array<any>;
  video: Array<any>;
  vrImg: Array<any>;
}
interface stateType {
  active: number;
  param: paramType;
  initInfo: initInfoType;
  showVideos: boolean;
  videoUrl: string;
  flag: boolean;
}
function stateInfo() {
  return {
    active: 0,
    param: {
      lat: "",
      lng: "",
      sourceId: "",
    },
    initInfo: {
      img: [] as any,
      shotImg: [] as any,
      detailImg: [] as any,
      video: [] as any,
      vrImg: [] as any,
    },
    flag: false,
    showVideos: false,
    videoUrl: "",
  };
}
function useEvent(state: stateType, router: any) {
  return {
    toVrDetail(url: string) {
      router.push({
        path: "/vr",
        query: {
          vrUrl:url,
        },
      });
    },
    showVideo(url: string) {
      console.log(url);
      
      state.videoUrl = url;
      state.showVideos = true;
    },
    preImage(type: number, id: string) {
      let arr: Array<string> = [],
        startPosition: number = 0,
        choArr = [] as any;
      if (type == 1) {
        choArr = state.initInfo.img;
      } else if (type == 2) {
        choArr = state.initInfo.shotImg;
      } else {
        choArr = state.initInfo.detailImg;
      }
      arr = choArr.map((item: any, index: number) => {
        if (item.id == id) {
          startPosition = index;
        }
        return item.url;
      });
      ImagePreview({
        images: arr,
        startPosition,
        closeable: true,
      });
    },
  };
}
export default defineComponent({
  components:{
    PreviewVideo
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive<stateType>(stateInfo());
    let { lat, lng } = store.state.lngLat;
    state.param.lat = lat;
    state.param.lng = lng;
    state.param.sourceId = route.query.id;
    let type = Number(route.query.type);
    if (type == 1) {
      state.active = 4;
    } else if (type == 2) {
      state.active = 1;
    } else {
      state.active = 3;
    }
    onMounted(() => {
      touristApi(state.param.sourceId, state.param.lat, state.param.lng).then(
        (res: any) => {
          state.flag = true;
          let { img, shotImg, detailImg, video, vrImg } = res.data.data as any;
          video = video.map((item:any)=>{
            item.time = convertSec2Str(item.time)
            return item
          })
          state.initInfo = { img, shotImg, detailImg, video, vrImg };
        }
      );
    });
    return {
      ...toRefs(state),
      ...useEvent(state, router),
    };
  },
});
